import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ReactMarkdown from 'react-markdown';
import { Anchor, Divider, Flex, Heading, Image, List, Paragraph } from '@zillow/constellation';

export const StyledListItem = styled(List.Item)`
  padding: 0;
`;

export default function Markdown({ children }) {
  return (
    <Flex display="flex" flexDirection="column" gap="xs">
      <ReactMarkdown
        linkTarget="_blank"
        components={{
          a: Anchor,
          h1: Heading,
          h2: Heading,
          h3: Heading,
          h4: Heading,
          h5: Heading,
          h6: Heading,
          hr: Divider,
          img: Image,
          li: StyledListItem,
          ol({ ...props }) {
            return <List appearance="number" {...props} />;
          },
          ul: List,
          p: Paragraph,
        }}
      >
        {children}
      </ReactMarkdown>
    </Flex>
  );
}

Markdown.propTypes = {
  children: PropTypes.string.isRequired,
};
